import { Spinner } from '@iwoca/orion';

import styles from './LoadingSpinner.module.css';

export const SpinnerComponent = () => (
    <div className={styles.spinner} data-testid="doc-loading-spinner">
        <Spinner size="large" />
    </div>
);

export const withLoadingSpinner = (
    WrappedComponent: React.ElementType,
    isLoadingRequirement: boolean,
    quantifier?: number,
    isOptional?: boolean
) => {
    return (
        <div className={styles.cardWrapper}>
            {isLoadingRequirement && <SpinnerComponent />}
            <WrappedComponent quantifier={quantifier} isOptional={isOptional} />
        </div>
    );
};

export default withLoadingSpinner;
